import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import scrollLock from 'scroll-lock';

@Injectable({ providedIn: 'root' })
export class ToastService {

	isOpen: BehaviorSubject<boolean>;
	message: BehaviorSubject<string>;
	type: BehaviorSubject<ToastType>;
	duration: BehaviorSubject<any>;
	showClose: BehaviorSubject<boolean>;
	lookScreen: BehaviorSubject<boolean>;
	htmlElement = document.getElementsByTagName('html');

	constructor() {
		this.isOpen = new BehaviorSubject(false);
		this.message = new BehaviorSubject<string>('');
		this.type = new BehaviorSubject<ToastType>('default');
		this.duration = new BehaviorSubject<any>(3);
		this.showClose = new BehaviorSubject<boolean>(false);
		this.lookScreen = new BehaviorSubject<boolean>(true);
	}

	/**
	 * Opens a toast with the given message, of the given (optional) type for
	 * the given duration
	 * @param message - the message to present on the toast
	 * @param type - the type (class) of the toast. Defaults to 'default'.
	 * @param duration - how long the toast stays on screen. Defaults to 3 seconds.
	 * @param showClose - show close button on the toast. Defaults to false.
	 * @param lookScreen - Look screen scroll when showing toast. Defaults to true.
	 */
	open(message: string, type: ToastType = 'default', duration: any = 3, showClose: boolean = false, lookScreen: boolean = true) {
		this.isOpen.next(true);
		this.message.next(message);
		this.type.next(type);
		this.duration.next(duration);
		this.showClose.next(showClose);
		this.lookScreen.next(lookScreen);
		this.isOpen.next(true);

		// Disable scroll on body
		if (lookScreen) {
			// Disable scroll on body
			this.htmlElement[0].classList.add('no-scroll');
			scrollLock.hide();
		}
	}

	close() {
		this.isOpen.next(false);

		// Enable scroll on body again
		this.htmlElement[0].classList.remove('no-scroll');
		scrollLock.show();
	}
}

type ToastType = 'default' | 'success' | 'info' | 'warning' | 'error' | 'default-wide';
